// extracted by css-extract-rspack-plugin
export default {"FormErrorsItem":"Form-module__FormErrorsItem__edbOltr"};